// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","inner":"NwhhBl","AniFadeIn":"dL9yEf","AniFadeOut":"_2dIfrz","AniRotate":"_5x4ZnD","AniPlaceholderFadeOut":"ekpH3E"};